import $http, { $httpCampaign } from '@/plugins/axios'
import AppService from '@/services/app.service'

const BotService = {
    getBotReport (channel, fromDate, toDate, pagination) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate
        }) + '&' + AppService.mapPagination(pagination)
        return $httpCampaign.get(`/rate-bot/${query}`)
    },
    getBotList () {
        return $http.get('/list-bot/')
    },
    getBotReportPieChart (channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate
        })
        return $httpCampaign.get(`/rate-bot-report-pie-chart/${query}`)
    },
    getBotReportBarChart (channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate
        })
        return $httpCampaign.get(`/rate-bot-report-bar-chart/${query}`)
    },
    getBotOverviewReportExcel (channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate,
            message_source: 'bot'
        })
        return $httpCampaign.get(`/rate-bot-report-overview-excel/${query}`, { responseType: 'blob' }).then((data) => {
            let fileURL = window.URL.createObjectURL(new Blob([data.data]))
            let fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', 'Bot-Overview.xlsx')
            document.body.appendChild(fileLink)
            fileLink.click()
        })
    },
    getBotReportDetailsExcel (channel, fromDate, toDate) {
        let query = AppService.buildQuery({
            channel: channel,
            start_date: fromDate,
            end_date: toDate,
            message_source: 'bot'
        })
        return $httpCampaign.get(`/rate-bot-report-details-excel/${query}`, { responseType: 'blob' }).then((data) => {
            let fileURL = window.URL.createObjectURL(new Blob([data.data]))
            let fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', 'Bot-Details.xlsx')
            document.body.appendChild(fileLink)
            fileLink.click()
        })
    }
}
export default BotService
